module.exports = __webpack_public_path__ + "static/media/dashcube.4bf3d937.svg";